<template>
  <CRow>
    <CCol col="12">
      <CCard style="overflow: inherit">
        <loader v-show="loading" />
        <CCardHeader>
          <c-q-header :data="data.group" @update="headerUpdate" @doUpdate="doUpdHdr" />
        </CCardHeader>
        <CCardBody>
          <ol class="question-container">
            <li v-for="(v, k) in data.detail" :key="k">
              <div class="question">
                <span v-html="v.question"></span>
                <div class="form-inline q-action-button">
                  <div class="btn-edit-delete">
                    <btn-delete @click="doDelete(v.id)"></btn-delete>
                    <btn-edit @click="doEdit(v)"></btn-edit>
                  </div>
                </div>
                <div class="answer">
                  <ol type="A">
                    <li v-for="(va, ka) in v.answers" :key="ka" v-bind:class="{'answer-correct': v.answer && v.answer.id == va.id}">
                      <span v-html="va.answer"/>
                    </li>
                  </ol>
                </div>
              </div>
            </li>
          </ol>
          <btn-add
            v-show="data.header && data.header.id"
            @click="addQuestion()"
            label="Tambah Soal"
          />
          <button
            v-show="!(data.header && data.header.id)"
            class="btn btn-success"
            @click="save"
          >
            Simpan
          </button>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import BtnDelete from "../../components/BtnDelete.vue";
import BtnEdit from "../../components/BtnEdit.vue";
import BtnAdd from "../../components/BtnAdd.vue";
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage } from "../../lib/helpers";
import CQHeader from "./CQHeader.vue";
import Loader from "../../components/Loader";
export default {
  components: { BtnEdit, BtnDelete, BtnAdd, CQHeader, Loader },
  data() {
    return {
      data: {
        header: {},
        detail: [],
      },
      loading: false,
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.id) {
      this.get(params.id);
    }
  },
  methods: {
    get(id) {
      this.getHeader(id);
      this.loading = true;
      HTTPAUTH.get(`/api/v1/admin/question-group/${id}/items`)
        .then((res) => {
          this.loading = false;
          this.data.detail = res.data.data;
        })
        .catch(() => {
          this.loading = false;
          // showErrorMessage(eres);
          this.data.detail = [];
        });
    },
    getHeader(id) {
      HTTPAUTH.get("/api/v1/admin/question-group/" + id)
        .then((res) => {
          this.data.header = res.data.data;
        })
        .catch(() => {
          // showErrorMessage(eres);
        });
    },
    removeQuestion(id) {
      HTTPAUTH.delete(`/api/v1/admin/series/${this.data.id}/detail/${id}`)
        .then(() => {
          this.get(this.data.id);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    doUpdHdr() {
      if (this.data.header.subject && this.data.header.subject.id) {
        this.data.header.subject_id = this.data.header.subject.id;
      }
      HTTPAUTH.put(`/api/v1/admin/question-group/${this.data.header.id}`, this.data.header)
        .then((res) => {
          this.$toasted.success("Data berhasil disimpan").goAway();
          const data = res.data.data;
          this.$router.push({ params: { id: data.id } });
          this.get(data.id);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    save() {
      if (this.data.header.subject && this.data.header.subject.id) {
        this.data.header.subject_id = this.data.header.subject.id;
      }
      HTTPAUTH.post("/api/v1/admin/question-group", this.data.header)
        .then((res) => {
          this.$toasted.success("Data berhasil disimpan").goAway();
          const data = res.data.data;
          this.$router.push({ params: { id: data.id } });
          this.get(data.id);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    headerUpdate(group) {
      this.data.header = group;
    },
    doEdit(v) {
      const params = this.$route.params;
      if (params && params.id) {
        this.$router.push({path: `/soal/baru/${params.id}/${v.id}`}).catch(() => {})
      }
    },
    doDelete(id) {
      const params = this.$route.params;
      HTTPAUTH.delete(`/api/v1/admin/question/${id}`).then(() => {
        if (params && params.id) {
          this.get(params.id);
        }
      });
    },
    addQuestion() {
      const params = this.$route.params;
      if (params && params.id) {
        this.$router.push({path: `/soal/baru/${params.id}/ya`})
      }
    },
  },
};
</script>